module.exports = __webpack_public_path__ + "img/2017.0c7f6cdf.jpg";